import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";
import { useQuery } from "@tanstack/react-query";

export const useBudgetGoals = () => {
  const queryFn = useApiRequest({
    url: "/budget-goals",
    method: HttpMethod.Get,
  });

  return useQuery({
    queryKey: ["budget-goals"],
    queryFn,
    placeholderData: [],
  });
};
